module.exports = __webpack_public_path__ + "static/media/img_ai_02.e107f970.png";